import ContractTermsForm from './ContractTermsForm';

export default ContractTermsForm;
